module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-11.dc0d82c5.png";